import './UserSettings.scss';
import React, { FC, useMemo } from 'react';
import Button from '@atoms/Button';
import Menu from '@atoms/Menu';
import Switch from '@atoms/Switch';
import { MdHelpOutline, MdTune } from 'react-icons/md';
import { useTypedSelector } from '@hooks/useTypedSelector';
import { useLocalStorage } from 'usehooks-ts';
import Tooltip from '@atoms/Tooltip';

const UserSettings: FC = () => {
    const currentUser = useTypedSelector((state) => state.auth.user);
    const [scrollByContent, setScrollByContent] = useLocalStorage<boolean>(
        `user-${currentUser.username}.scrollByContentInTables`,
        false,
    );

    const menuContent = useMemo(() => {
        return (
            <div className="user-settings__content">
                <div className="user-settings__item">
                    <Switch
                        label={
                            <span className="user-settings__label">
                                <span className="user-settings__label-text">Прокрутка курсором в таблицах</span>
                                <Tooltip openDelay={100} background="black" position="bottom">
                                    <button type="button" className="user-settings__label-icon">
                                        <MdHelpOutline size="16" />
                                    </button>
                                    Позволяет прокручивать таблицу, удерживая и двигая её содержимое мышью или пальцем.
                                </Tooltip>
                            </span>
                        }
                        value={scrollByContent}
                        between={true}
                        reverse={true}
                        onChange={(value) => {
                            setScrollByContent(value);
                        }}
                    />
                </div>
            </div>
        );
    }, [scrollByContent, setScrollByContent]);

    return (
        <div className="user-settings">
            <Menu content={menuContent} position="bottom-end" offsetValue={{ mainAxis: 7, crossAxis: 0 }}>
                <div className="user-settings__menu">
                    <Button
                        buttonType="round"
                        title="Пользовательские настройки"
                        data-testid="user-settings-button"
                        textColor="neutral"
                        size="m"
                        startAdornment={<MdTune size="24" />}
                    />
                </div>
            </Menu>
        </div>
    );
};

export default UserSettings;
